import { MutationHookOptions, useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import ListGroup from 'react-bootstrap/ListGroup';
import Media from 'react-bootstrap/Media';
import Modal from 'react-bootstrap/Modal';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Row from 'react-bootstrap/Row';
import Spinner from 'react-bootstrap/Spinner';
import { LinkContainer } from 'react-router-bootstrap';
import Select from 'react-select';
import { CurationCategoryMatch } from '../../../../../__gqltypes__';
import type {
  BackfillCurationSp2PlaylistBadgesMutation,
  BackfillCurationSp2PlaylistBadgesMutationVariables,
  ContentPacksQuery,
  CreateCurationContentPackByArtistsMutation,
  CreateCurationContentPackByArtistsMutationVariables,
  CreateCurationContentPackByCsvMutation,
  CreateCurationContentPackByCsvMutationVariables,
  CreateCurationContentPackByUrlMutation,
  CreateCurationContentPackByUrlMutationVariables,
  CreateCurationContentPackFromSp2Mutation,
  CreateCurationContentPackFromSp2MutationVariables,
  CurationSp2BadgeOptionsQuery,
  GetCategoriesQuery,
} from '../../../../../__gqltypes__';
import Loader from '../../components/Loader';
import Pagination from '../../components/Pagination';
import PlaylistsSidebar from '../../components/PlaylistsSidebar';
import PlaylistState from '../../components/PlaylistState';
import SearchBar from '../../components/SearchBar';
import AddPlaylistPopup from '../../popups/AddPlaylistPopup';
import { AddPlaylistValues } from '../../popups/utils';
import { downloadCsvFile } from '../../utils/csvExport';
import mutations from '../../utils/mutations';
import queries from '../../utils/queries';
import { InputType } from '../PlaylistInfo/utils';
import './Playlists.css';

const createByUrlOptions: MutationHookOptions<
  CreateCurationContentPackByUrlMutation,
  CreateCurationContentPackByUrlMutationVariables
> = {
  // @ts-ignore
  update: (proxy, { data: { createCurationContentPackByUrl } }) => {
    // const cached = proxy.readQuery({ query: queries.CURATION_CONTENT_PACKS, variables: { offset: 0 } });
    // console.log('cached', cached, createCurationContentPackByUrl);
    // cached.curation.contentPacks.list = [
    //   createCurationContentPackByUrl.curationContentPack,
    //   ...cached.curation.contentPacks.list,
    // ]; // push to front!
    // console.log('pushing', cached);
    // cached.curation.contentPacks.totalCount++;
    // console.log('writing', cached);
    // proxy.writeQuery({ query: queries.CURATION_CONTENT_PACKS, data: cached, variables: { offset: 0 } });
  },
};

const createByCsvOptions: MutationHookOptions<
  CreateCurationContentPackByCsvMutation,
  CreateCurationContentPackByCsvMutationVariables
> = {
  // @ts-ignore
  update: (proxy, { data: { createCurationContentPackByCSV } }) => {
    // const cached = proxy.readQuery({ query: queries.CURATION_CONTENT_PACKS, variables: { offset: 0 } });
    // push to front!
    // cached.curation.contentPacks.list.unshift(createCurationContentPackByCSV.curationContentPack);
    // cached.curation.contentPacks.totalCount++;
    // proxy.writeQuery({ query: queries.CURATION_CONTENT_PACKS, data: cached });
  },
};

const createFromSp2Options: MutationHookOptions<
  CreateCurationContentPackFromSp2Mutation,
  CreateCurationContentPackFromSp2MutationVariables
> = {
  // @ts-ignore
  update: (proxy, { data: { createCurationContentPackFromSp2 } }) => {
    // const cached = proxy.readQuery({ query: queries.CURATION_CONTENT_PACKS, variables: { offset: 0 } });
    // push to front!
    // cached.curation.contentPacks.list.unshift(createCurationContentPackFromSp2.curationContentPack);
    // cached.curation.contentPacks.totalCount++;
    // proxy.writeQuery({ query: queries.CURATION_CONTENT_PACKS, data: cached });
  },
};

const createByArtistsOptions: MutationHookOptions<
  CreateCurationContentPackByArtistsMutation,
  CreateCurationContentPackByArtistsMutationVariables
> = {
  // @ts-ignore
  update: (proxy, { data: { createCurationContentPackByArtists } }) => {
    // const cached = proxy.readQuery({ query: queries.CURATION_CONTENT_PACKS, variables: { offset: 0 } });
    // push to front!
    // cached.curation.contentPacks.list.unshift(createCurationContentPackByArtists.curationContentPack);
    // cached.curation.contentPacks.totalCount++;
    // proxy.writeQuery({ query: queries.CURATION_CONTENT_PACKS, data: cached });
  },
};

type Props = {
  match: { params: { id: string; version: string } };
  history: any;
};

const Playlists = ({ match, history }: Props) => {
  const [showModal, setShowModal] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchName, setSearchName] = useState('');
  const [searchCategories, setSearchCategories] = useState<string[]>([]);
  const [categoryMatch, setCategoryMatch] = useState<CurationCategoryMatch>(CurationCategoryMatch.AND);
  const [searchPrimaryBadge, setSearchPrimaryBadge] = useState<string | null>(null);
  const [searchSecondaryBadge, setSearchSecondaryBadge] = useState<string | null>(null);
  const [showBadgeSyncConfirm, setShowBadgeSyncConfirm] = useState(false);
  // total is unknown until the first batch answers
  const [badgeSync, setBadgeSync] = useState<{ synced: number; failed: number; total: number | null } | null>(null);
  const stopBadgeSyncRef = useRef(false);
  const [loadingCsvExport, setLoadingCsvExport] = useState(false);
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  console.log('match', params);

  const [page, setPage] = useState(parseInt(params.page ?? 1, 10));

  const {
    loading: contentPacksLoading,
    data: contentPacksData,
    refetch: refetchContentPacks,
  } = useQuery<ContentPacksQuery>(queries.CURATION_CONTENT_PACKS, {
    variables: { offset: (page - 1) * 100 },
    notifyOnNetworkStatusChange: true,
  });
  const [
    fetchContentPacksByName,
    {
      loading: contentPacksByNameLoading,
      data: contentPacksByNameData,
      refetch: refetchContentPacksByName,
      called: contentPacksByNameCalled,
    },
  ] = useLazyQuery(queries.CURATION_CONTENT_PACKS_BY_NAME, {
    notifyOnNetworkStatusChange: true,
  });
  const { data: categoriesData } = useQuery<GetCategoriesQuery>(queries.GET_CATEGORIES);
  const categoryOptions = [...(categoriesData?.app?.contentCategories ?? [])]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((category) => ({ value: category.id, label: category.name }));
  const { data: badgeOptionsData, refetch: refetchBadgeOptions } = useQuery<CurationSp2BadgeOptionsQuery>(
    queries.CURATION_SP2_BADGE_OPTIONS
  );
  const toBadgeOptions = (badges: readonly string[] | undefined) =>
    (badges ?? []).map((badge) => ({ value: badge, label: badge }));
  const primaryBadgeOptions = toBadgeOptions(badgeOptionsData?.curationSp2BadgeOptions.primary);
  const secondaryBadgeOptions = toBadgeOptions(badgeOptionsData?.curationSp2BadgeOptions.secondary);
  const badgeSyncStatus = badgeOptionsData?.curationSp2BadgeOptions;
  const allBadgesSynced = badgeSyncStatus && badgeSyncStatus.syncedPlaylists >= badgeSyncStatus.linkedPlaylists;
  const [backfillSp2Badges] = useMutation<
    BackfillCurationSp2PlaylistBadgesMutation,
    BackfillCurationSp2PlaylistBadgesMutationVariables
  >(mutations.BACKFILL_CURATION_SP2_PLAYLIST_BADGES);
  const { refetch: fetchCsvExport } = useQuery(queries.CONTENT_PACKS_CSV_EXPORT, {
    skip: true,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
  });

  const [createCurationContentPackByUrl, { loading: createByUrlLoading }] = useMutation<
    CreateCurationContentPackByUrlMutation,
    CreateCurationContentPackByUrlMutationVariables
  >(mutations.CREATE_CURATION_CONTENT_PACK_BY_URL, createByUrlOptions);
  const [createCurationContentPackByCSV, { loading: createByCsvLoading }] = useMutation<
    CreateCurationContentPackByCsvMutation,
    CreateCurationContentPackByCsvMutationVariables
  >(mutations.CREATE_CURATION_CONTENT_PACK_BY_CSV, createByCsvOptions);
  const [createCurationContentPackFromSp2, { loading: createFromSp2Loading }] = useMutation<
    CreateCurationContentPackFromSp2Mutation,
    CreateCurationContentPackFromSp2MutationVariables
  >(mutations.CREATE_CURATION_CONTENT_PACK_FROM_SP2, createFromSp2Options);
  const [createCurationContentPackByArtists, { loading: createByArtistsLoading }] = useMutation<
    CreateCurationContentPackByArtistsMutation,
    CreateCurationContentPackByArtistsMutationVariables
  >(mutations.CREATE_CURATION_CONTENT_PACK_BY_ARTISTS, createByArtistsOptions);

  const mutationLoading = createByCsvLoading || createByUrlLoading || createFromSp2Loading || createByArtistsLoading;

  const openSpotifyPlaylist = () => setShowModal(true);
  const closeSpotifyPlaylist = () => setShowModal(false);

  const onAddPlaylist = (inputType: keyof typeof InputType, payload: AddPlaylistValues) => {
    console.log('adding playlist', payload, inputType);
    closeSpotifyPlaylist();

    if (mutationLoading) {
      return;
    }

    if (inputType === 'SPOTIFY' && payload && 'spotifyURI' in payload) {
      createCurationContentPackByUrl({ variables: { input: payload } });
    } else if (inputType === 'CSV' && payload && 'file' in payload) {
      createCurationContentPackByCSV({ variables: { input: payload } });
    } else if (inputType === 'SP2' && payload && 'sp2PlaylistId' in payload) {
      createCurationContentPackFromSp2({ variables: { input: payload } });
    } else if (inputType === 'SPOTIFY_ARTISTS' && payload && 'artistIds' in payload) {
      createCurationContentPackByArtists({ variables: { input: payload } });
    }
  };

  const onClickPagination = (index: number) => {
    const offset = (index - 1) * 100;
    refetchContentPacks({ offset });
    setPage(index);
    history.push({
      pathname: '/sp3/playlist/',
      search: `?page=${index}`,
    });

    console.log('page', index);
  };

  // Name, categories and SP2 badges combine: any one alone also searches, clearing all goes back to the paginated list.
  // Several categories match with AND (playlist has all of them) or OR (playlist has at least one).
  const runSearch = ({
    name = searchName,
    categories = searchCategories,
    matchMode = categoryMatch,
    primaryBadge = searchPrimaryBadge,
    secondaryBadge = searchSecondaryBadge,
  }: {
    name?: string;
    categories?: string[];
    matchMode?: CurationCategoryMatch;
    primaryBadge?: string | null;
    secondaryBadge?: string | null;
  }) => {
    const variables = {
      name: name.trim() || null,
      categories: categories.length > 0 ? categories : null,
      categoryMatch: matchMode,
      sp2PrimaryBadge: primaryBadge,
      sp2SecondaryBadge: secondaryBadge,
    };
    if (variables.name || variables.categories || variables.sp2PrimaryBadge || variables.sp2SecondaryBadge) {
      setIsSearching(true);
      if (contentPacksByNameCalled) {
        refetchContentPacksByName(variables);
      } else {
        fetchContentPacksByName({ variables });
      }
    } else {
      setIsSearching(false);
      handleRefresh();
    }
  };

  const onSearchPlaylist = (searchInput: string) => {
    setSearchName(searchInput);
    runSearch({ name: searchInput });
  };

  const onChangeCategories = (selected: readonly { value: string; label: string }[]) => {
    const categories = selected.map((option) => option.value);
    setSearchCategories(categories);
    runSearch({ categories });
  };

  const onChangeCategoryMatch = (matchMode: CurationCategoryMatch) => {
    if (matchMode === categoryMatch) {
      return;
    }
    setCategoryMatch(matchMode);
    // AND/OR only changes the result when at least two categories are picked
    if (searchCategories.length > 1) {
      runSearch({ matchMode });
    }
  };

  const onChangePrimaryBadge = (selected: { value: string } | null) => {
    const primaryBadge = selected?.value ?? null;
    setSearchPrimaryBadge(primaryBadge);
    runSearch({ primaryBadge });
  };

  const onChangeSecondaryBadge = (selected: { value: string } | null) => {
    const secondaryBadge = selected?.value ?? null;
    setSearchSecondaryBadge(secondaryBadge);
    runSearch({ secondaryBadge });
  };

  // Copies the badges of the SP2 playlists never synced yet, a small batch per call so the progress moves,
  // until none is left or the curator stops it
  const SP2_BADGE_SYNC_BATCH = 25;
  const syncSp2Badges = async () => {
    setShowBadgeSyncConfirm(false);
    if (badgeSync) {
      return;
    }
    stopBadgeSyncRef.current = false;
    let synced = 0;
    let failed = 0;
    let total: number | null = null;
    setBadgeSync({ synced, failed, total });
    try {
      while (!stopBadgeSyncRef.current) {
        const { data } = await backfillSp2Badges({ variables: { limit: SP2_BADGE_SYNC_BATCH } });
        const result = data?.backfillCurationSp2PlaylistBadges;
        if (!result) {
          break;
        }
        if (total === null) {
          total = result.processed + result.remaining;
        }
        synced += result.processed - result.failed;
        failed = result.failed;
        setBadgeSync({ synced, failed, total });
        // stop when everything left keeps failing, the next sync retries them
        if (result.remaining === 0 || result.processed === result.failed) {
          break;
        }
      }
      const stopped = stopBadgeSyncRef.current ? 'stopped' : 'done';
      alert(
        `SP2 badges sync ${stopped}: ${synced} playlists synced${
          failed ? `, ${failed} could not be read (retry later)` : ''
        }.`
      );
    } catch (e) {
      alert(`SP2 badges sync stopped after ${synced} playlists: ${(e as Error).message}`);
    } finally {
      setBadgeSync(null);
      refetchBadgeOptions();
    }
  };

  const loading = contentPacksLoading || contentPacksByNameLoading;

  const handleRefresh = () => {
    if (!loading) {
      refetchContentPacks();
    }
  };

  const handleCsvExport = () => {
    if (!loadingCsvExport) {
      setLoadingCsvExport(true);
      fetchCsvExport().then(({ data }) => {
        setLoadingCsvExport(false);
        downloadCsvFile(data.curation.contentPackCsvExport.content, 'playlist_summary');
      });
    }
  };

  let contentPacks = contentPacksData?.curation?.contentPacks?.list ?? [];
  if (isSearching) {
    contentPacks = contentPacksByNameData ? contentPacksByNameData.curationContentPacksByName : [];
  }

  const maxPage = contentPacksData?.curation?.contentPacks
    ? contentPacksData.curation.contentPacks.totalCount % 100 === 0
      ? Math.floor(contentPacksData.curation.contentPacks.totalCount / 100)
      : Math.floor(contentPacksData.curation.contentPacks.totalCount / 100) + 1
    : 1;

  return (
    <>
      <Row className="justify-content-between mb-2">
        <Col xl={4}>
          <h1>Playlists</h1>
          <div className="d-flex justify-content-between">
            <Button disabled={loading} onClick={handleRefresh}>
              <i className="fas fa-redo mr-2" />
              Refresh
            </Button>
            <Button className="ml-4" disabled={loading || loadingCsvExport} onClick={handleCsvExport}>
              <i className="fa fa-download mr-2" />
              {loadingCsvExport ? 'Generating CSV file...' : 'Download playlist summary CSV'}
            </Button>
          </div>
        </Col>
        <Col className="d-flex mb-2 align-items-baseline mt-4 mt-xl-0">
          <SearchBar placeholder="Playlist or artist to search" onSubmit={onSearchPlaylist} />
          <Form inline>
            <Button variant="success" disabled={mutationLoading} onClick={openSpotifyPlaylist}>
              {mutationLoading ? 'Adding...' : 'Add'}
            </Button>
          </Form>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xl={{ span: 8, offset: 4 }} className="d-flex align-items-center">
          <div className="flex-grow-1 mr-3">
            <Select
              isMulti
              placeholder="Filter by categories..."
              options={categoryOptions}
              value={categoryOptions.filter((option) => searchCategories.includes(option.value))}
              onChange={onChangeCategories}
            />
          </div>
          <ButtonGroup aria-label="Category match">
            <Button
              variant={categoryMatch === CurationCategoryMatch.AND ? 'primary' : 'outline-primary'}
              onClick={() => onChangeCategoryMatch(CurationCategoryMatch.AND)}
              title="Playlists that have all the selected categories"
            >
              AND
            </Button>
            <Button
              variant={categoryMatch === CurationCategoryMatch.OR ? 'primary' : 'outline-primary'}
              onClick={() => onChangeCategoryMatch(CurationCategoryMatch.OR)}
              title="Playlists that have at least one of the selected categories"
            >
              OR
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xl={{ span: 8, offset: 4 }} className="d-flex align-items-center">
          <div className="flex-grow-1 mr-3">
            <Select
              isClearable
              placeholder="SP2 primary badge..."
              options={primaryBadgeOptions}
              value={primaryBadgeOptions.find((option) => option.value === searchPrimaryBadge) ?? null}
              onChange={onChangePrimaryBadge}
            />
          </div>
          <div className="flex-grow-1 mr-3">
            <Select
              isClearable
              placeholder="SP2 secondary badge..."
              options={secondaryBadgeOptions}
              value={secondaryBadgeOptions.find((option) => option.value === searchSecondaryBadge) ?? null}
              onChange={onChangeSecondaryBadge}
            />
          </div>
          {badgeSyncStatus && !badgeSync && (
            <span
              className={`text-nowrap small mr-2 ${allBadgesSynced ? 'text-muted' : 'text-warning'}`}
              title="SP2 playlists linked to SP3 whose badges are synced"
            >
              Synced {badgeSyncStatus.syncedPlaylists} / {badgeSyncStatus.linkedPlaylists}
            </span>
          )}
          {badgeSync ? (
            <Button
              variant="outline-danger"
              onClick={() => {
                stopBadgeSyncRef.current = true;
              }}
            >
              <i className="fas fa-stop mr-2" />
              Stop
            </Button>
          ) : (
            <Button
              variant="primary"
              className="text-nowrap"
              disabled={!!allBadgesSynced}
              onClick={() => setShowBadgeSyncConfirm(true)}
              title={
                allBadgesSynced
                  ? 'All SP2 playlists are synced'
                  : 'Copies the badges of the SP2 playlists not synced yet (admin only)'
              }
            >
              <i className="fas fa-sync mr-2" />
              Sync SP2 badges
            </Button>
          )}
        </Col>
      </Row>
      {badgeSync && (
        <Row className="mb-3">
          <Col xl={{ span: 8, offset: 4 }}>
            <div className="d-flex align-items-center mb-1">
              <Spinner animation="border" size="sm" className="mr-2" />
              {badgeSync.total === null
                ? 'Syncing SP2 badges: reading the first playlists from SP2...'
                : `Syncing SP2 badges: ${badgeSync.synced} / ${badgeSync.total} playlists${
                    badgeSync.failed ? ` (${badgeSync.failed} could not be read)` : ''
                  }`}
            </div>
            <ProgressBar
              animated
              now={badgeSync.total ? (badgeSync.synced / badgeSync.total) * 100 : 100}
              variant={badgeSync.total === null ? 'info' : undefined}
              label={badgeSync.total ? `${Math.floor((badgeSync.synced / badgeSync.total) * 100)}%` : ''}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col xl={4}>
          <PlaylistsSidebar />
        </Col>
        <Col>
          {loading ? (
            <Loader />
          ) : (
            <ListGroup variant="flush">
              {contentPacks.map((playlist) => (
                <LinkContainer key={playlist.id} to={`/sp3/playlist/${playlist.originId}`}>
                  <ListGroup.Item className="listgroup-small" action>
                    <Media>
                      <Image src={playlist.picture} />
                      <Media.Body>
                        {playlist.name}
                        <PlaylistState state={playlist.state || null} sp2Only={!!playlist.sp2Only} />
                      </Media.Body>
                    </Media>
                  </ListGroup.Item>
                </LinkContainer>
              ))}
            </ListGroup>
          )}
        </Col>
      </Row>

      {!isSearching && (
        <div className="d-flex justify-content-end mt-4">
          <Pagination active={page} num={maxPage} onClick={onClickPagination} />
        </div>
      )}

      <Modal show={showBadgeSyncConfirm} onHide={() => setShowBadgeSyncConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Sync SP2 badges?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Sync the badges of all SP2 playlists not synced yet? This can take a few minutes.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBadgeSyncConfirm(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={syncSp2Badges}>
            Start sync
          </Button>
        </Modal.Footer>
      </Modal>

      <AddPlaylistPopup show={showModal} onHide={closeSpotifyPlaylist} onAddPlaylist={onAddPlaylist} />
    </>
  );
};

export default Playlists;
